"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
exports.getSpacing = function (breakpointType, direction) {
    var baseSpacing;
    switch (breakpointType) {
        case 'xs': // mobile (small)
            baseSpacing = direction === 'horizontal' ? 16 : 24;
            break;
        case 'sm': // tablet/laptop (medium)
            baseSpacing = 24;
            break;
        case 'md': // desktop (large)
        case 'lg': // desktop (large)
            baseSpacing = 32;
            break;
        default:
            baseSpacing = 24;
            break;
    }
    return base_1.spacing(baseSpacing);
};
//# sourceMappingURL=spacing.js.map